<div class="confirmation-dialog-container">
  <h2 mat-dialog-title></h2>
  <mat-dialog-content *ngIf="title">
    Are you sure you want to delete '{{ title }}' notification from the list ?
  </mat-dialog-content>
  <mat-dialog-content *ngIf="name && mode !== 'ROLE-DELETE' && mode !== 'REGION-DELETE' && mode !== 'DEPARTMENT-DELETE'">
    Are you sure you want to delete '{{ name }}' from the user list ?
  </mat-dialog-content>
  <mat-dialog-content *ngIf="deleteRole && mode === 'ROLE-DELETE'">
    Are you sure you want to delete '{{deleteRole.name}}' from the role list ?
  </mat-dialog-content>
  <mat-dialog-content *ngIf="deleteRegion && mode === 'REGION-DELETE'">
    Are you sure you want to delete '{{deleteRegion.regionName}}' from the Region list ?
  </mat-dialog-content>
  <mat-dialog-content *ngIf="deleteDeparment && mode === 'DEPARTMENT-DELETE'">
    Are you sure you want to delete '{{deleteDeparment.name}}' from the Department list ?
  </mat-dialog-content>
  <mat-dialog-content *ngIf="position">
    Are you sure you want to delete '{{ position }}' from the list ?
  </mat-dialog-content>
  <mat-dialog-content *ngIf="deleteTagList?.length > 0 && mode === 'DELETE'">
    Are you sure you want to delete
    <span class="comma-separated-list">
      <ng-template ngFor let-tag [ngForOf]="deleteTagList">
        <span>{{ tag.tagName }}</span>
      </ng-template>
    </span>
    from the list ?
  </mat-dialog-content>
  <mat-dialog-content *ngIf="addTagList && mode === 'ADD'">
    Do you want to add this tag?
    <p class="comma-separated-list">
      Tag:
      <ng-template ngFor let-tag [ngForOf]="addTagList">
        <span>{{ tag.tagName }}</span>
      </ng-template>
    </p>
  </mat-dialog-content>
  <mat-dialog-actions align="center">
    <button
      tabindex="-1"
      mat-dialog-close
      mat-raised-button
      color="basic"
      class="mat-button-medium"
      (click)="onConfirmation(false)"
    >
      Cancel
    </button>
    <button
      mat-raised-button
      color="primary"
      class="mat-button-medium"
      *ngIf="mode === 'DELETE' || mode === 'ROLE-DELETE' || mode === 'REGION-DELETE' || mode === 'DEPARTMENT-DELETE'"
      [mat-dialog-close]="true"
      (click)="onConfirmation(true, data.value ? data.value:data.teamValue)"
    >
      Delete
    </button>
   
    <button
      mat-raised-button
      color="primary"
      class="mat-button-medium"
      *ngIf="mode === 'ADD'"
      [mat-dialog-close]="true"
      (click)="onConfirmation(true, data.value)"
    >
      ADD
    </button>
  </mat-dialog-actions>
</div>
